
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/dialogue/radix-dialog";
import EditPayrollForm from "./EditPayrollForm";

const EditPayrollDialogue = ({ children, payroll }) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="max-w-[70%] rounded-2xl p-6 bg-card">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-gray-800">
            Edit Payroll
          </DialogTitle>
        </DialogHeader>
        <div>
          <EditPayrollForm payroll={payroll} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditPayrollDialogue;
